import {
  DataValidator,
  IsArray,
  Required,
  transformKeys,
} from "@/utils/type-vaildator";
import api from "./api";

/** 原始接口响应 */
interface AudioContentIllegalResponse {
  risk_words: string[];
}

export interface AudioContentIllegalRequest {
  inputText: string;
}

export class AudioContentIllegalData {
  @Required("Risk words cannot be empty")
  @IsArray("Risk words must be an array")
  riskWords: string[];
}

const transformAndValidate = (
  response: AudioContentIllegalResponse
): AudioContentIllegalData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AudioContentIllegalData);
  } catch (error) {
    console.error("Audio content illegal data validation failed:", error.message);
    throw error;
  }
};

/** 检测音频文案中的违规词 */
export const audioContentIllegal = async ({
  inputText,
}: AudioContentIllegalRequest): Promise<AudioContentIllegalData> => {
  const response = await api.post<AudioContentIllegalResponse>("/audio/content/illegal", {
    input_text: inputText,
  }, {
    timeout: 60 * 1000, // 60秒超时
  });
  return transformAndValidate(response.data);
};
